import script from "./nav-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-header.vue?vue&type=script&setup=true&lang=ts"

import "./nav-header.vue?vue&type=style&index=0&id=7363e48d&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7363e48d"]])

export default __exports__